

const dataGames = {
    'x-bomb-fire': {
        name: 'X Bomb Fire',
        desc: 'Every win in X Bomb Fire explodes to make room for more and each new cascade pushes your multiplier toward 10x. Catch the expanding wild Bomb and watch the reels light up. Just one more spin and it could all go off!',
        features: [
            '5x3',
            'Multiplier',
            'Cascade game',
            'Expanding wild'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/x-bomb-fire/0.webp'),
            require('../images/games/x-bomb-fire/1.webp'),
            require('../images/games/x-bomb-fire/2.webp'),
            require('../images/games/x-bomb-fire/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/x-bomb-fire/',
    },
    '5-wild-crown': {
        name: '5 Wild Crown',
        desc: '5 Wild Crown hits hard from the very first spin. Line up the fruits, catch the big wins and keep the reels rolling. One spin is never enough!',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatter symbols',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-wild-crown/0.webp'),
            require('../images/games/5-wild-crown/1.webp'),
            require('../images/games/5-wild-crown/2.webp'),
            require('../images/games/5-wild-crown/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/5-wild-crown/',
    },
    'double-crown-deluxe': {
        name: 'Double Crown Deluxe',
        desc: 'Double Crown Deluxe doubles the fun and doubles the wins. Watch the wilds stack up and hope the x2 wild lands in the middle. Don’t miss this one!',
        features: [
            '5x3',
            'Multiplier',
            'Special Wild Symbol',
            '10 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/double-crown-deluxe/0.webp'),
            require('../images/games/double-crown-deluxe/1.webp'),
            require('../images/games/double-crown-deluxe/2.webp'),
            require('../images/games/double-crown-deluxe/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/double-crown-deluxe/',
    },
    'x-wild-pumpkin': {
        name: 'X Wild Pumpkin',
        desc: 'X Wild Pumpkin makes this the wildest night of the year. Light up the pumpkins and watch the reels catch fire. Spin it if you dare!',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Multipliers',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/x-wild-pumpkin/0.webp'),
            require('../images/games/x-wild-pumpkin/1.webp'),
            require('../images/games/x-wild-pumpkin/2.webp'),
            require('../images/games/x-wild-pumpkin/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/x-wild-pumpkin/',
    },
    'double-wild-heart-halloween': {
        name: 'Double Wild Heart Halloween',
        desc: 'In Double Wild Heart Halloween, every spin could be the one. When the wild heart appears your prize instantly doubles for an even bigger spooky payoff!',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatter Symbol',
            'Multiplier'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/double-wild-heart-halloween/0.webp'),
            require('../images/games/double-wild-heart-halloween/1.webp'),
            require('../images/games/double-wild-heart-halloween/2.webp'),
            require('../images/games/double-wild-heart-halloween/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/double-wild-heart-halloween/',
    },
    'wild-crown-1000': {
        name: 'Wild Crown 1000',
        desc: 'Wild Crown 1000 brings hot spins and exciting possibilities with every reel. Keep the action going and see where your luck leads you.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatter Symbol',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/wild-crown-1000/0.webp'),
            require('../images/games/wild-crown-1000/1.webp'),
            require('../images/games/wild-crown-1000/2.webp'),
            require('../images/games/wild-crown-1000/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/wild-crown-1000/',
    },
    'multi-heart-10': {
        name: 'Multi Heart 10',
        desc: 'In Multi Heart 10, every heart beats with more power! One Expanding Wild doubles your wins, two boost them by 3x, and with three Expanding Wilds, your prizes explode with a 5x multiplier!',
        features: [
            'Expanding Wild Symbol',
            'Scatter symbols',
            '5x3',
            'Multiplier'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/multi-heart-10/0.webp'),
            require('../images/games/multi-heart-10/1.webp'),
            require('../images/games/multi-heart-10/2.webp'),
            require('../images/games/multi-heart-10/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/multi-heart-10/',
    },
    '10-crown-deluxe': {
        name: '10 Crown Deluxe',
        desc: 'Every spin in 10 Crown Deluxe brings a new chance to hit more. Land the Crown in the right place and boost your winning potential for bigger rewards!',
        features: [
            'Expanding Wild Symbol',
            'Scatter symbols',
            '5x3',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-crown-deluxe/0.webp'),
            require('../images/games/10-crown-deluxe/1.webp'),
            require('../images/games/10-crown-deluxe/2.webp'),
            require('../images/games/10-crown-deluxe/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/10-crown-deluxe/',
    },
    'wild-heart-1000': {
        name: 'Wild Heart 1000',
        desc: 'Wild Heart 1000 brings hot spins and exciting possibilities with every reel. Keep the action going and see where your luck leads you.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatter Symbol',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/wild-heart-1000/0.webp'),
            require('../images/games/wild-heart-1000/1.webp'),
            require('../images/games/wild-heart-1000/2.webp'),
            require('../images/games/wild-heart-1000/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/wild-heart-1000/',
    },
    '10-heart-deluxe': {
        name: '10 Heart Deluxe',
        desc: 'Every spin in 10 Heart Deluxe brings a new chance to hit more. Land the Heart in the right place and boost your winning potential for bigger rewards!',
        features: [
            'Expanding Wild Symbol',
            'Scatter symbols',
            '5x3',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-heart-deluxe/0.webp'),
            require('../images/games/10-heart-deluxe/1.webp'),
            require('../images/games/10-heart-deluxe/2.webp'),
            require('../images/games/10-heart-deluxe/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/10-heart-deluxe/',
    },
    'clover-fire-1000': {
        name: 'Clover Fire 1000',
        desc: 'Clover Fire 1000 brings hot spins and exciting possibilities with every reel. Keep the action going and see where your luck leads you.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatter Symbol',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/clover-fire-1000/0.webp'),
            require('../images/games/clover-fire-1000/1.webp'),
            require('../images/games/clover-fire-1000/2.webp'),
            require('../images/games/clover-fire-1000/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/clover-fire-1000/',
    },
    'x-crown-fire': {
        name: 'X Crown Fire',
        desc: 'X Crown Fire turns every spin into a new opportunity. Feel the excitement grow with expanding Crown Wilds and multipliers up to x5, creating more chances for rewarding wins.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Multipliers',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/x-crown-fire/0.webp'),
            require('../images/games/x-crown-fire/1.webp'),
            require('../images/games/x-crown-fire/2.webp'),
            require('../images/games/x-crown-fire/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/x-crown-fire/',
    },
    'lucky-lucky-bells': {
        name: 'Lucky Lucky Bells',
        desc: 'Chase the bells in Lucky Lucky Bells and hit three of them to collect the massive payout! Every bell gives different reward up to x1000 grand bell win!',
        features: [
            '3x3',
            'Scatter Symbols',
            'Wild Symbol',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/lucky-lucky-bells/0.webp'),
            require('../images/games/lucky-lucky-bells/1.webp'),
            require('../images/games/lucky-lucky-bells/2.webp'),
            require('../images/games/lucky-lucky-bells/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/lucky-lucky-bells/',
    },
    'x-chilli-hot': {
        name: 'X Chilli Hot',
        desc: 'X Chilli Hot keeps the heat rising from the first spin. With win multipliers up to x5, every payout has the potential to get even hotter.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Multipliers',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/x-chilli-hot/0.webp'),
            require('../images/games/x-chilli-hot/1.webp'),
            require('../images/games/x-chilli-hot/2.webp'),
            require('../images/games/x-chilli-hot/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/x-chilli-hot/',
    },
    'multi-crown-5': {
        name: 'Multi Crown 5',
        desc: 'Spin into royal wins with Multi Crown 5 ! Crowns expand with power and bring x2, x3 or x5 multipliers to boost your payouts. One crown can rule the reels!',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Multipliers',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/multi-crown-5/0.webp'),
            require('../images/games/multi-crown-5/1.webp'),
            require('../images/games/multi-crown-5/2.webp'),
            require('../images/games/multi-crown-5/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/multi-crown-5/',
    },
    '10-clover-deluxe': {
        name: '10 Clover Deluxe',
        desc: 'Every spin in 10 Clover Deluxe brings a new chance to hit more. Land the Clover in the right place and boost your winning potential for bigger rewards!',
        features: [
            'Expanding Wild Symbol',
            'Scatter symbols',
            '5x3',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-clover-deluxe/0.webp'),
            require('../images/games/10-clover-deluxe/1.webp'),
            require('../images/games/10-clover-deluxe/2.webp'),
            require('../images/games/10-clover-deluxe/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/10-clover-deluxe/',
    },
    'crown-deluxe-2x': {
        name: 'Crown Deluxe 2x',
        desc: 'Keep spinning and wait for the crown to land. In Crown Deluxe 2X, one moment is enough to double your win instantly.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatter symbol',
            'Multiplier'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/crown-deluxe-2x/0.webp'),
            require('../images/games/crown-deluxe-2x/1.webp'),
            require('../images/games/crown-deluxe-2x/2.webp'),
            require('../images/games/crown-deluxe-2x/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/crown-deluxe-2x/',
    },
    '5-crown-deluxe': {
        name: '5 Crown Deluxe',
        desc: 'Take your spin in 5 Crown Deluxe and play it your way! Fast spins, clear hits, and a classic feel that never gets old.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatter symbols',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-crown-deluxe/0.webp'),
            require('../images/games/5-crown-deluxe/1.webp'),
            require('../images/games/5-crown-deluxe/2.webp'),
            require('../images/games/5-crown-deluxe/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/5-crown-deluxe/',
    },
    'x-wild-heart': {
        name: 'X Wild Heart',
        desc: 'In X Wild Heart, everything revolves around the Wild Heart. Land it and your win multiplies instantly, hit more across the reels and the payout keeps climbing.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Multipliers',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/x-wild-heart/0.webp'),
            require('../images/games/x-wild-heart/1.webp'),
            require('../images/games/x-wild-heart/2.webp'),
            require('../images/games/x-wild-heart/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/x-wild-heart/',
    },
    'cosmic-fruits': {
        name: 'Cosmic Fruits',
        desc: 'Get into Cosmic Fruits and keep it moving. Quick spins, colorful hits, and a flow that doesn’t let go.',
        features: [
            '5x3',
            '5 lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/cosmic-fruits/0.webp'),
            require('../images/games/cosmic-fruits/1.webp'),
            require('../images/games/cosmic-fruits/2.webp'),
            require('../images/games/cosmic-fruits/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/cosmic-fruits/',
    },
    'heart-deluxe-2x': {
        name: 'Heart Deluxe 2x',
        desc: 'Keep spinning and wait for the heart to land. In Heart Deluxe 2X, one moment is enough to double your win instantly.',
        features: [
            '5x3',
            'Multiplier',
            'Scatter Symbol',
            'Expanding Wild Symbol',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/heart-deluxe-2x/0.webp'),
            require('../images/games/heart-deluxe-2x/1.webp'),
            require('../images/games/heart-deluxe-2x/2.webp'),
            require('../images/games/heart-deluxe-2x/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/heart-deluxe-2x/',
    },
    '5-clover-deluxe': {
        name: '5 Clover Deluxe',
        desc: 'Take your spin in 5 Clover Deluxe and play it your way! Fast spins, clear hits, and a classic feel that never gets old.',
        features: [
            '5x3',
            '5 lines',
            'Scatter Symbols',
            'Expanding Wild Symbol',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-clover-deluxe/0.webp'),
            require('../images/games/5-clover-deluxe/1.webp'),
            require('../images/games/5-clover-deluxe/2.webp'),
            require('../images/games/5-clover-deluxe/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/5-clover-deluxe/',
    },
    'x-wild-crown': {
        name: 'X Wild Crown',
        desc: ' In X Wild Crown, everything revolves around the Crown. Land it and your win multiplies instantly, hit more across the reels and the payout keeps climbing.',
        features: [
            '5x3',
            '5 lines',
            'Multipliers',
            'Expanding Wild Symbol',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/x-wild-crown/0.webp'),
            require('../images/games/x-wild-crown/1.webp'),
            require('../images/games/x-wild-crown/2.webp'),
            require('../images/games/x-wild-crown/3.webp'),
        ],
        url: 'https://static.redstone.rs/games/x-wild-crown/',
    },
    'pure-hot-5': {
        name: 'Pure Hot 5',
        desc: 'Heat up the reels in Pure Hot 5 and stay in the run. Fast action, clear hits, and a flow that keeps you chasing more.',
        features: [
            '5x3',
            '5 lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/pure-hot-5/0.png'),
            require('../images/games/pure-hot-5/1.png'),
            require('../images/games/pure-hot-5/2.png'),
            require('../images/games/pure-hot-5/3.png'),
        ],
        url: 'https://static.redstone.rs/games/pure-hot-5/',
    },
    'clover-deluxe-2x': {
        name: 'Clover Deluxe 2x',
        desc: 'Keep spinning and wait for the Clover to land. In Clover Deluxe 2X, one moment is enough to double your win instantly.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatter Symbols',
            'Multiplier'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/clover-deluxe-2x/0.png'),
            require('../images/games/clover-deluxe-2x/1.png'),
            require('../images/games/clover-deluxe-2x/2.png'),
            require('../images/games/clover-deluxe-2x/3.png'),
        ],
        url: 'https://static.redstone.rs/games/clover-deluxe-2x/',
    },
    '5-heart-deluxe': {
        name: '5 Heart Deluxe',
        desc: 'Take your spin in 5 Heart Deluxe and play it your way! Fast spins, clear hits, and a classic feel that never gets old.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatter Symbols',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-heart-deluxe/0.png'),
            require('../images/games/5-heart-deluxe/1.png'),
            require('../images/games/5-heart-deluxe/2.png'),
            require('../images/games/5-heart-deluxe/3.png'),
        ],
        url: 'https://static.redstone.rs/games/5-heart-deluxe/',
    },
    'fruit-fire': {
        name: 'Fruit Fire',
        desc: 'Fruit Fire brings back the core slot experience. Simple mechanics, recognizable symbols, and steady engagement across five lines.',
        features: [
            '5x3',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/fruit-fire/0.png'),
            require('../images/games/fruit-fire/1.png'),
            require('../images/games/fruit-fire/2.png'),
            require('../images/games/fruit-fire/3.png'),
        ],
        url: 'https://static.redstone.rs/games/fruit-fire/',
    },
    'x-clover-fire': {
        name: 'X Clover Fire',
        desc: 'In X Clover Fire, everything revolves around the Clover. Land it and your win multiplies instantly, hit more across the reels and the payout keeps climbing.',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Multipliers',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/x-clover-fire/0.png'),
            require('../images/games/x-clover-fire/1.png'),
            require('../images/games/x-clover-fire/2.png'),
            require('../images/games/x-clover-fire/3.png'),
        ],
        url: 'https://static.redstone.rs/games/x-clover-fire/',
    },
    '5-clover-fire-blast': {
        name: '5 Clover Fire Blast',
        desc: '5 Clover Fire Blast ignites the reels with a Clover that spreads around itself. The surrounding Wild mechanic expands outward, increasing hit potential instantly.',
        features: [
            '5x3',
            'Surrounding Wild Symbol',
            'Scatter',
            '5 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-clover-fire-blast/0.png'),
            require('../images/games/5-clover-fire-blast/1.png'),
            require('../images/games/5-clover-fire-blast/2.png'),
            require('../images/games/5-clover-fire-blast/3.png'),
        ],
        url: 'https://static.redstone.rs/games/5-clover-fire-blast/',
    },
    'dice-drop-10': {
        name: 'Dice Drop 10',
        desc: 'Roll the dice and win big with expanding wilds on up to 8 surrounding positions! Landing two wild symbols in the right positions will fill the full screen.',
        features: [
            '5x3',
            'Surrounding Wild Symbol',
            'Scatter',
            '10 lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/dice-drop-10/0.png'),
            require('../images/games/dice-drop-10/1.png'),
            require('../images/games/dice-drop-10/2.png'),
            require('../images/games/dice-drop-10/3.png'),
        ],
        url: 'https://static.redstone.rs/games/dice-drop-10/',
    },
    '5-bell-fire': {
        name: '5 Bell Fire',
        desc: 'The expanding Bell takes control of the central reels! A familiar format enhanced with strong visual impact and concentrated payouts.',
        features: [
            '5x3',
            'Expanding Wild Symbols',
            'Scatter symbols',
            '5 lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-bell-fire/0.png'),
            require('../images/games/5-bell-fire/1.png'),
            require('../images/games/5-bell-fire/2.png'),
            require('../images/games/5-bell-fire/3.png'),
        ],
        url: 'https://static.redstone.rs/games/5-bell-fire/',
    },
    'clover-rush-5': {
        name: 'Clover Rush 5',
        desc: 'Get ready for the luckiest spins in Clover Rush 5! With Expanding Wilds on all reels, every spin could turn into a winning rush.',
        features: [
            '5x3',
            'Expanding Wild Symbols',
            '5 lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/clover-rush-5/0.png'),
            require('../images/games/clover-rush-5/1.png'),
            require('../images/games/clover-rush-5/2.png'),
            require('../images/games/clover-rush-5/3.png'),
        ],
        url: 'https://static.redstone.rs/games/clover-rush-5/',
    },
    'joker-x5': {
        name: 'Joker X5',
        desc: 'Each expanding Joker carries a random multiplier between x2 and x5, with total multiplier reaching up to x60. No win after the Joker lands? Respin gives you another chance.',
        features: [
            '3x3',
            'Expanding Wild Symbols',
            'Multipliers',
            'Respin'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/joker-x5/0.png'),
            require('../images/games/joker-x5/1.png'),
            require('../images/games/joker-x5/2.png'),
        ],
        url: 'https://static.redstone.rs/games/joker-x5/',
    },
    'multi-clover-5': {
        name: 'Multi Clover 5',
        desc: 'Spin into a world of clovers and magic with Multi Clover 5. More is better - watch as expanding wilds boost your winnings with x2, x3 or x5 multipliers!',
        features: [
            '5x3',
            'Expanding Wild Symbols',
            'Multipliers',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/multi-clover-5/0.png'),
            require('../images/games/multi-clover-5/1.png'),
            require('../images/games/multi-clover-5/2.png'),
            require('../images/games/multi-clover-5/3.png'),
        ],
        url: 'https://static.redstone.rs/games/multi-clover-5/',
    },
    'respin-fortune': {
        name: 'Respin Fortune',
        desc: 'In Respin Fortune, the dragon is a symbol of luck and power. Catch it on the center reel to activate a free respin and extend your chance for a bigger win!',
        features: [
            '5x3',
            'Expanding Wild Symbols',
            'Scatter',
            'Respin',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/respin-fortune/0.png'),
            require('../images/games/respin-fortune/1.png'),
            require('../images/games/respin-fortune/2.png'),
            require('../images/games/respin-fortune/3.png'),
        ],
        url: 'https://static.redstone.rs/games/respin-fortune/',
    },
    'double-wild-diamond': {
        name: 'Double Wild Diamond',
        desc: 'Double Wild Diamond builds tension with every spin. Hit the diamond in the middle reel and win double instantly.',
        features: [
            '5x3',
            'Expanding Wild Symbols',
            'Scatter',
            'Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/double-wild-diamond/0.png'),
            require('../images/games/double-wild-diamond/1.png'),
            require('../images/games/double-wild-diamond/2.png'),
            require('../images/games/double-wild-diamond/3.png'),
        ],
        url: 'https://static.redstone.rs/games/double-wild-diamond/',
    },
    'cupids-wild-hearts': {
        name: `Cupid's Wild Hearts`,
        desc: `Let Cupid guide your spin in Cupid's Wild Heart. Follow the arrow and see where the Wild appears!`,
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/cupids-wild-hearts/0.png'),
            require('../images/games/cupids-wild-hearts/1.png'),
            require('../images/games/cupids-wild-hearts/2.png'),
            require('../images/games/cupids-wild-hearts/3.png'),
        ],
        url: 'https://static.redstone.rs/games/cupids-wild-hearts/',
    },
    'rolling-hearts-10': {
        name: 'Rolling Hearts 10',
        desc: 'In Rolling Hearts 10, every spin brings a new chance on 10 lively paylines. When the Heart symbol lands, it spreads to neighboring spots and boosts your winning potential. A classic feel with a fun surprise.',
        features: [
            '5x3',
            'Surrounding Wild Symbol',
            'Scatter',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/rolling-hearts-10/0.png'),
            require('../images/games/rolling-hearts-10/1.png'),
            require('../images/games/rolling-hearts-10/2.png'),
            require('../images/games/rolling-hearts-10/3.png'),
        ],
        url: 'https://static.redstone.rs/games/rolling-hearts-10/',
    },
    'inferno-hot-40': {
        name: 'Inferno Hot 40',
        desc: 'Inferno Hot 40 sets the reels on fire with 40 blazing lines! Classic fruit symbols bring juicy wins, while exciting Bonus Games turn up the heat even more. Feel the burn and experience true casino thrill!',
        features: [
            'Wild',
            '4x5',
            'Scatter',
            'Bonus',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/inferno-hot-40/0.png'),
            require('../images/games/inferno-hot-40/1.png'),
            require('../images/games/inferno-hot-40/2.png'),
            require('../images/games/inferno-hot-40/3.png'),
        ],
        url: 'https://static.redstone.rs/games/inferno-hot-40/',
    },
    'double-clover-fire-christmas': {
        name: 'Double Clover Fire Christmas',
        desc: 'The central Wild lights up the reels with festive magic, expanding and delivering fiery wins with a dazzling x2 multiplier!',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatters',
            'Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/double-clover-fire-christmas/0.png'),
            require('../images/games/double-clover-fire-christmas/1.png'),
            require('../images/games/double-clover-fire-christmas/2.png'),
            require('../images/games/double-clover-fire-christmas/3.png'),
        ],
        url: 'https://static.redstone.rs/games/double-clover-fire-christmas/',
    },
    '5-wild-diamond': {
        name: '5 Wild Diamond',
        desc: 'Expanding Wilds spread across the reels with pure passion, bringing elegant and thrilling wins straight from the diamond!',
        features: [
            '5x3',
            'Expanding Wild Symbol',
            'Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-wild-diamond/0.png'),
            require('../images/games/5-wild-diamond/1.png'),
            require('../images/games/5-wild-diamond/2.png'),
            require('../images/games/5-wild-diamond/3.png'),
        ],
        url: 'https://static.redstone.rs/games/5-wild-diamond/',
    },
    '9-of-a-kind': {
        name: '9 Of A Kind',
        desc: 'Hit 3 Scatters to unlock a powerful transformation! A random symbol is selected, all matching positions are filled, and the entire grid multiplies for massive win potential. One symbol. One screen. Huge payout.',
        features: [
            '3x3',
            'Special Symbol',
            'Multiplier Wheel',
            '5 lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/9-of-a-kind/0.png'),
            require('../images/games/9-of-a-kind/1.png'),
            require('../images/games/9-of-a-kind/2.png'),
            require('../images/games/9-of-a-kind/3.png'),
            require('../images/games/9-of-a-kind/4.png'),
        ],
        url: 'https://static.redstone.rs/games/9-of-a-kind/',
    },
    'respin-gems': {
        name: 'Respin Gems',
        desc: 'Respin Gems brings sparkling excitement! Dazzling gems fill the reels, while the Joker Expanding Wild ignites thrilling respins. Every appearance means new chances and even bigger wins!',
        features: [
            'Respin',
            'Expanding Wild',
            '5 lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/respin-gems/0.png'),
            require('../images/games/respin-gems/1.png'),
            require('../images/games/respin-gems/2.png'),
            require('../images/games/respin-gems/3.png'),
        ],
        url: 'https://static.redstone.rs/games/respin-gems/',
    },
    'chilli-double-40': {
        name: 'Chilli Double 40',
        desc: 'Spice up your game with Chilli Double 40! When the middle reel lands a Double Expanding Wild, the heat rises and your wins can multiply like never before!',
        features: [
            'Expanding Wild',
            '4x5',
            'Scatter',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/chilli-double-40/0.png'),
            require('../images/games/chilli-double-40/1.png'),
            require('../images/games/chilli-double-40/2.png'),
            require('../images/games/chilli-double-40/3.png'),
        ],
        url: 'https://static.redstone.rs/games/chilli-double-40/',
    },
    'crown-royale': {
        name: 'Crown Royale',
        desc: 'Step into the world of royal wins! In Crown Royale, every spin brings a chance to claim your crown. Wilds fit for a king!',
        features: [
            'Expanding Wild',
            '3x5',
            'Mutlipliers',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/crown-royale/0.png'),
            require('../images/games/crown-royale/1.png'),
            require('../images/games/crown-royale/2.png'),
            require('../images/games/crown-royale/3.png'),
        ],
        url: 'https://static.redstone.rs/games/crown-royale/',
    },
    'crown-blast-40': {
        name: 'Crown Blast 40',
        desc: 'In Crown Blast 40, every crown spreads its power! Surrounding Wilds expand across the reels, turning nearby symbols into royal opportunities for big wins!',
        features: [
            'Surrounding Wild',
            '4x5',
            'Scatter',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/crown-blast-40/0.png'),
            require('../images/games/crown-blast-40/1.png'),
            require('../images/games/crown-blast-40/2.png'),
            require('../images/games/crown-blast-40/3.png'),
        ],
        url: 'https://static.redstone.rs/games/crown-blast-40/',
    },
    'inferno-hot-20': {
        name: 'Inferno Hot 20',
        desc: 'Inferno Hot 20 sets the reels on fire with 20 blazing lines! Classic fruit symbols bring juicy wins, while exciting Bonus Games turn up the heat even more. Feel the burn and experience true casino thrill!',
        features: [
            'Wild',
            '3x5',
            'Scatter',
            'Bonus',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/inferno-hot-20/0.png'),
            require('../images/games/inferno-hot-20/1.png'),
            require('../images/games/inferno-hot-20/2.png'),
            require('../images/games/inferno-hot-20/3.png'),
        ],
        url: 'https://static.redstone.rs/games/inferno-hot-20/',
    },
    'chilli-hot-40': {
        name: 'Chilli Hot 40',
        desc: 'In Chilli Hot 40, the heat is always on! Expanding Wilds spread across the reels, turning up the spice and bringing wins with every spin!',
        features: [
            'Expanding Wild',
            '4x5',
            'Scatter',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/chilli-hot-40/0.png'),
            require('../images/games/chilli-hot-40/1.png'),
            require('../images/games/chilli-hot-40/2.png'),
            require('../images/games/chilli-hot-40/3.png'),
        ],
        url: 'https://static.redstone.rs/games/chilli-hot-40/',
    },
    '20-wild-heart': {
        name: '20 Wild Heart',
        desc: 'Every Wild Heart grows to cover the reels, bringing more chances for thrilling payouts!',
        features: [
            'Expanding Wild',
            '3x5',
            'Scatter',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/20-wild-heart/0.png'),
            require('../images/games/20-wild-heart/1.png'),
            require('../images/games/20-wild-heart/2.png'),
            require('../images/games/20-wild-heart/3.png'),
        ],
        url: 'https://static.redstone.rs/games/20-wild-heart/',
    },
    'multi-heart-5': {
        name: 'Multi Heart 5',
        desc: 'In Multi Heart 5, every heart beats with more power! One Expanding Wild doubles your wins, two boost them by 3x, and with three Expanding Wilds, your prizes explode with a 5x multiplier!        ',
        features: [
            'Expanding Wild',
            '4x5',
            'Scatter',
            'Multiplier'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/multi-heart-5/0.png'),
            require('../images/games/multi-heart-5/1.png'),
            require('../images/games/multi-heart-5/2.png'),
            require('../images/games/multi-heart-5/3.png'),
        ],
        url: 'https://static.redstone.rs/games/multi-heart-5/',
    },
    'clover-field-40': {
        name: 'Clover Field 40',
        desc: 'In Clover Field 40, every wild grows with luck! Surrounding Wilds expand in all directions, turning nearby symbols into winners and bringing you endless chances to strike big prizes!        ',
        features: [
            'Spreading Wild',
            '4x5',
            'Scatter',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/clover-field-40/0.png'),
            require('../images/games/clover-field-40/1.png'),
            require('../images/games/clover-field-40/2.png'),
            require('../images/games/clover-field-40/3.png'),
        ],
        url: 'https://static.redstone.rs/games/clover-field-40/',
    },
    '10-wild-crown-halloween': {
        name: '10 Wild Crown Halloween',
        desc: 'In 10 Wild Crown Halloween, every crown can bring big prizes. Up to 3 Expanding Wilds give you even more chances to win this spooky season!',
        features: [
            'Expanding Wild',
            '3x5',
            'Scatter',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-wild-crown-halloween/0.png'),
            require('../images/games/10-wild-crown-halloween/1.png'),
            require('../images/games/10-wild-crown-halloween/2.png'),
            require('../images/games/10-wild-crown-halloween/3.png'),
        ],
        url: 'https://static.redstone.rs/games/10-wild-crown-halloween/',
    },
    '5-clover-fire-halloween': {
        name: '5 Clover Fire Halloween',
        desc: '5 Clover Fire Halloween mixes lucky clovers with Halloween thrills. Expanding Wilds spread across the reels and can light up your wins in a big way',
        features: [
            'Expanding Wild',
            '3x5',
            'Scatter',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-clover-fire-halloween/0.png'),
            require('../images/games/5-clover-fire-halloween/1.png'),
            require('../images/games/5-clover-fire-halloween/2.png'),
            require('../images/games/5-clover-fire-halloween/3.png'),
        ],
        url: 'https://static.redstone.rs/games/5-clover-fire-halloween/',
    },
    'double-wild-heart': {
        name: 'Double Wild Heart',
        desc: 'Every Wild Heart grows to cover the reels, bringing more chances for thrilling payouts',
        features: [
            'Expanding Wild',
            '3x5',
            'Scatter',
            'Multiplier'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/double-wild-heart/0.png'),
            require('../images/games/double-wild-heart/1.png'),
            require('../images/games/double-wild-heart/2.png'),
            require('../images/games/double-wild-heart/3.png'),
        ],
        url: 'https://static.redstone.rs/games/double-wild-heart/',
    },
    '777-extra-chance': {
        name: '777 Extra Chance',
        desc: 'Every seven brings more. Land two or more sevens in 777 Extra Chance and the reels respin for even more winning potential!',
        features: [
            'Respin Feature',
            '3x5',
            'Classic',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/777-extra-chance/0.png'),
            require('../images/games/777-extra-chance/1.png'),
            require('../images/games/777-extra-chance/2.png'),
            require('../images/games/777-extra-chance/3.png'),
        ],
        url: 'https://static.redstone.rs/games/777-extra-chance/',
    },
    'sevens-heaven': {
        name: 'Sevens Heaven',
        desc: 'A perfect mix of luck and heat. Sevens Heaven is a 3×3 slot where any combination of sevens pays, and the bonus round fills the reels with wilds and multipliers.',
        features: [
            'Wild',
            'Multiplier',
            'Buy Bonus',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/sevens-heaven/0.png'),
            require('../images/games/sevens-heaven/1.png'),
            require('../images/games/sevens-heaven/2.png'),
            require('../images/games/sevens-heaven/3.png'),
        ],
        url: 'https://static.redstone.rs/games/sevens-heaven/',
    },
    '10-extra-bank': {
        name: '10 Extra Bank',
        desc: 'With 10 lines and chain wins from either side, 10 Extra Bank delivers nonstop action. Watch for the middle wild - it can multiply your wins big time.',
        features: [
            'Wild',
            'Multiplier',
            'x17500 Max Win',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-extra-bank/0.png'),
            require('../images/games/10-extra-bank/1.png'),
            require('../images/games/10-extra-bank/2.png'),
            require('../images/games/10-extra-bank/3.png'),
        ],
        url: 'https://static.redstone.rs/games/10-extra-bank/',
    },
    '5-clover-fire-6-reels': {
        name: '5 Clover Fire 6 Reels',
        desc: 'More clovers, more fire, more ways to win! 5 Clover Fire 6 Reels delivers even more thrills on every spin!',
        features: [
            'Expanding Wild',
            'Scatter',
            'Six Reels',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-clover-fire-6-reels/0.png'),
            require('../images/games/5-clover-fire-6-reels/1.png'),
            require('../images/games/5-clover-fire-6-reels/2.png'),
            require('../images/games/5-clover-fire-6-reels/3.png'),
        ],
        url: 'https://static.redstone.rs/games/5-clover-fire-6-reels/',
    },
    'crown-drop': {
        name: 'Crown Drop',
        desc: 'Watch the crowns drop and the wins grow! Crowns land on the center reels and drop down, expanding as they go. With every fall, they bring new chances to win big!',
        features: [
            'Wild Drop',
            'Scatter',
            '5x5',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/crown-drop/0.png'),
            require('../images/games/crown-drop/1.png'),
            require('../images/games/crown-drop/2.png'),
            require('../images/games/crown-drop/3.png'),
        ],
        url: 'https://static.redstone.rs/games/crown-drop/',
    },
    'reel-x27': {
        name: 'REEL X5 27 Ways',
        desc: 'Reel x5 – 27 Ways adds excitement with more ways to win. One extra reel still decides how big your wins can get! Spin, win and multiply!',
        features: [
            'Extra Reel',
            'Multipliers',
            '3x3',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/reel-x27/0.png'),
            require('../images/games/reel-x27/1.png'),
            require('../images/games/reel-x27/2.png'),
            require('../images/games/reel-x27/3.png'),
        ],
        url: 'https://static.redstone.rs/games/reel-x5-27-ways/',
    },
    'heart-royale': {
        name: 'Heart Royale',
        desc: 'Heart Royale brings the heat with expanding multipliers! Watch them hit the middle reels and boost your wins to new heights. Spin today for massive prizes!',
        features: [
            'Expanding wild symbol',
            '5x3',
            'Multipliers',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/heart-royale/0.png'),
            require('../images/games/heart-royale/1.png'),
            require('../images/games/heart-royale/2.png'),
            require('../images/games/heart-royale/3.png'),
        ],
        url: 'https://static.redstone.rs/games/heart-royale/',
    },
    'double-crown-5': {
        name: 'Double Crown 5',
        desc: 'Double Crown 5 is where fortunes are made! Land the special crown on the middle reel to double your wins with a x2 multiplier!',
        features: [
            'Wild Symbol',
            '3x3',
            'Multiplier wild',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/double-crown-5/0.png'),
            require('../images/games/double-crown-5/1.png'),
            require('../images/games/double-crown-5/2.png'),
            require('../images/games/double-crown-5/3.png'),
        ],
        url: 'https://static.redstone.rs/games/double-crown-5/',
    },
    '40-wild-crown': {
        name: '40 Wild Crown',
        desc: '40 Wild Crown is your ticket to big wins! With 40 paylines, every spin brings you closer to epic wins! Jump in and claim your throne!',
        features: [
            'Expanding Wild',
            '4x5',
            'Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-wild-crown/0.png'),
            require('../images/games/40-wild-crown/1.png'),
            require('../images/games/40-wild-crown/2.png'),
            require('../images/games/40-wild-crown/3.png'),
        ],
        url: 'https://static.redstone.rs/games/40-wild-crown/',
    },
    '777-expand': {
        name: '777 Expand',
        desc: '777: Expand is all about the lucky seven – when it lands on the middle three reels, it expands into a powerful wild. Big surprises and bold wins are just a spin away.',
        features: [
            'Expanding Wild',
            '3x5',
            'Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/777-expand/0.png'),
            require('../images/games/777-expand/1.png'),
            require('../images/games/777-expand/2.png'),
            require('../images/games/777-expand/3.png'),
        ],
        url: 'https://static.redstone.rs/games/777-expand/',
    },
    'double-wild-crown': {
        name: 'Double Wild Crown',
        desc: 'Double Wild Crown is made for those who like their spins sharp and their wins bigger. One symbol is all it takes — hit the crown in the center reel and watch your payout jump x2.',
        features: [
            'Expanding Wild',
            '3x5',
            'Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/double-wild-crown/0.png'),
            require('../images/games/double-wild-crown/1.png'),
            require('../images/games/double-wild-crown/2.png'),
            require('../images/games/double-wild-crown/3.png'),
        ],
        url: 'https://static.redstone.rs/games/double-wild-crown/',
    },
    'multi-crown-10': {
        name: 'Multi Crown 10',
        desc: 'Spin into royal wins with Multi Crown 10! Crowns expand with power and bring x2, x3 or x5 multipliers to boost your payouts!',
        features: [
            'Expanding Wild',
            'Multiplier',
            '3x5',
            'Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/multi-crown-10/0.png'),
            require('../images/games/multi-crown-10/1.png'),
            require('../images/games/multi-crown-10/2.png'),
            require('../images/games/multi-crown-10/3.png'),
        ],
        url: 'https://static.redstone.rs/games/multi-crown-10/',
    },
    'clover-drop': {
        name: 'Clover Drop',
        desc: 'Watch the clovers drop and the wins grow! Clovers land on the center reels and drop down, expanding as they go. With every fall, they bring new chances to win big!',
        features: [
            'Wild symbol',
            'Drop mechanic',
            '5x5',
            'Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/clover-drop/0.png'),
            require('../images/games/clover-drop/1.png'),
            require('../images/games/clover-drop/2.png'),
            require('../images/games/clover-drop/3.png'),
        ],
        url: 'https://static.redstone.rs/games/clover-drop/',
    },
    '5-star-fire': {
        name: '5 Star Fire',
        desc: 'One spin and the stars explode! 5 Star Fire keeps it hot with expanding stars and nonstop thrills.',
        features: [
            'Expanding Wild',
            '3x5',
            'Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-star-fire/0.png'),
            require('../images/games/5-star-fire/1.png'),
            require('../images/games/5-star-fire/2.png'),
            require('../images/games/5-star-fire/3.png'),
        ],
        url: 'https://static.redstone.rs/games/5-star-fire/',
    },
    'bonus-stars': {
        name: 'Bonus Stars',
        desc: 'Shine bright with Bonus Stars! Packed with stacked wilds and thrilling bonus features, this game turns every spin into shiny wins!',
        features: [
            'Stacked wild',
            '30 lines',
            'Bonus',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/bonus-stars/0.png'),
            require('../images/games/bonus-stars/1.png'),
            require('../images/games/bonus-stars/2.png'),
            require('../images/games/bonus-stars/3.png'),
        ],
        url: 'https://static.redstone.rs/games/bonus-stars/',
    },
    '40-joker-fire': {
        name: '40 Joker Fire',
        desc: 'Jokers bring the fun and the wins in 40 Joker Fire! With 40 paylines and classic slot action, every spin can set the reels on fire!',
        features: [
            'Stacked wild',
            '40 lines',
            'Scatter',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-joker-fire/0.png'),
            require('../images/games/40-joker-fire/1.png'),
            require('../images/games/40-joker-fire/2.png'),
            require('../images/games/40-joker-fire/3.png'),
        ],
        url: 'https://static.redstone.rs/games/40-joker-fire/',
    },
    '10-wild-heart': {
        name: '10 Wild Heart',
        desc: 'With 10 Wild Heart, every spin brings you closer to exciting wins. Wilds bring the heat and with just a little luck, the payouts can be unforgettable!',
        features: [
            'Expanding wild',
            '10 lines',
            'Two Scatters',
            'Free Games'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-wild-heart/0.png'),
            require('../images/games/10-wild-heart/1.png'),
            require('../images/games/10-wild-heart/2.png'),
            require('../images/games/10-wild-heart/3.png'),
        ],
        url: 'https://static.redstone.rs/games/10-wild-heart/',
    },
    'sticky-tiki': {
        name: 'Sticky Tiki',
        desc: 'Spin into a tropical adventure with Sticky Tiki, where sticky symbols lock in place and keep the wins rolling!',
        features: [
            'Respin',
            'Expanding Wild',
            'Max Win x10000',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/sticky-tiki/0.png'),
            require('../images/games/sticky-tiki/1.png'),
            require('../images/games/sticky-tiki/2.png'),
            require('../images/games/sticky-tiki/3.png'),
        ],
        url: 'https://static.redstone.rs/games/sticky-tiki/',
    },
    'hot-rush-triple-star': {
        name: 'Hot Rush Triple Star',
        desc: 'Hot Rush Triple Star delivers wild excitement with expanding wilds that lock in place, triggering thrilling respins!',
        features: [
            'Respin',
            'Expanding Wild',
            '5 lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/hot-rush-triple-star/0.png'),
            require('../images/games/hot-rush-triple-star/1.png'),
            require('../images/games/hot-rush-triple-star/2.png'),
            require('../images/games/hot-rush-triple-star/3.png'),
        ],
        url: 'https://static.redstone.rs/games/hot-rush-triple-star/',
    },
    'sweet-respins': {
        name: 'Sweet Respins',
        desc: 'Sweet Respins brings you a sugary adventure with every spin! Keep an eye out for the jackpot - land three lollipops and win x10000 your bet!',
        features: [
            'Respin',
            'Expanding Wild',
            'Max Win x10000',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/sweet-respins/0.png'),
            require('../images/games/sweet-respins/1.png'),
            require('../images/games/sweet-respins/2.png'),
            require('../images/games/sweet-respins/3.png'),
        ],
        url: 'https://static.redstone.rs/games/sweet-respins/',
    },
    'farm-fiesta': {
        name: 'Farm Fiesta',
        desc: 'Farm Fiesta turns a quiet farm into a party - packed slot! WIth up to 12 Sticky Wilds, this farm is all about big wins! How wild can your fiesta get?',
        features: [
            'Bonus',
            'Sticky Wild',
            'Buy Bonus',
            'Boosted Bet',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/farm-fiesta/0.png'),
            require('../images/games/farm-fiesta/1.png'),
            require('../images/games/farm-fiesta/2.png'),
            require('../images/games/farm-fiesta/3.png'),
            require('../images/games/farm-fiesta/4.png'),
        ],
        url: 'https://static.redstone.rs/games/farm-fiesta/',
    },
    'reel-x5': {
        name: 'REEL X5',
        desc: 'Spin, win and multiply! Reel x5 is a classic fruit slot with a game changing twist - one extra reel that decides how big your wins get!',
        features: [
            'Multiplier',
            '3x3',
            'Classic Mechanics',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/reel-x5/0.png'),
            require('../images/games/reel-x5/1.png'),
            require('../images/games/reel-x5/2.png'),
            require('../images/games/reel-x5/3.png'),
        ],
        url: 'https://static.redstone.rs/games/reel-x5/',
    },
    'multi-clover-10': {
        name: 'Multi Clover 10',
        desc: 'Spin into a world of clovers and magic with Multi Clover 10. Each clover can change everything - watch as expanding wilds boost your winnings with x2, x3 or x5 multipliers!',
        features: [
            'Multiplier',
            'Expanding Wild',
            'x1615',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/multi-clover-10/0.png'),
            require('../images/games/multi-clover-10/1.png'),
            require('../images/games/multi-clover-10/2.png'),
            require('../images/games/multi-clover-10/3.png'),
        ],
        url: 'https://static.redstone.rs/games/multi-clover-10/',
    },
    'divine-strike': {
        name: 'Divine Strike',
        desc: 'Presenting "Divine Strike", where the gods of Ancient Greece bring you fortunes of up to x2000! Trigger Free Games and claim your divine rewards!',
        features: [
            'Buy Bonus',
            'Wild',
            'x2000',
            'Boosted Bet',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/divine-strike/0.png'),
            require('../images/games/divine-strike/1.png'),
            require('../images/games/divine-strike/2.png'),
            require('../images/games/divine-strike/3.png'),
        ],
        url: 'https://static.redstone.rs/games/divine-strike/',
    },
    'star-chaser': {
        name: 'Star Chaser',
        desc: 'Star Chaser offers astronomical rewards! Gather 15 scatters and win 10,000x your bet. The stars are waiting — are you ready to chase them?',
        features: [
            'Scatter',
            'x1000 Max Win',
            '5x3',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/star-chaser/0.png'),
            require('../images/games/star-chaser/1.png'),
            require('../images/games/star-chaser/2.png'),
            require('../images/games/star-chaser/3.png'),
        ],
        url: 'https://static.redstone.rs/games/star-chaser/',
    },
    'eternal-hearts-10': {
        name: 'Eternal Hearts 10',
        desc: 'Can you gather all 15 hearts? In Eternal Hearts, the challenge leads to unforgettable rewards in the bonus round.',
        features: [
            'Wild Symbol',
            'Lock n Cash feature',
            'Bonus',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/eternal-hearts-10/0.png'),
            require('../images/games/eternal-hearts-10/1.png'),
            require('../images/games/eternal-hearts-10/2.png'),
            require('../images/games/eternal-hearts-10/3.png'),
        ],
        url: 'https://static.redstone.rs/games/eternal-hearts-10/',
    },
    'clover-royale': {
        name: 'Clover Royale',
        desc: 'Clover Royale blends strategy and luck - trigger the Face Off feature and let the multipliers make your prize bigger.',
        features: [
            'x2225 Max Win',
            'Multipliers',
            'Expanding Symbol',
            'Face Off Feature',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/clover-royale/0.png'),
            require('../images/games/clover-royale/1.png'),
            require('../images/games/clover-royale/2.png'),
            require('../images/games/clover-royale/3.png'),
        ],
        url: 'https://static.redstone.rs/games/clover-royale/',
    },
    'cosmic-sevens': {
        name: 'Cosmic Sevens',
        desc: 'Spin to the stars and beyond with Cosmic Sevens! Land a seven, expand the wilds and aim for a massive 3000x win!',
        features: [
            '10 Lines',
            '5x3',
            'Expanding Symbol',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/cosmic-sevens/0.png'),
            require('../images/games/cosmic-sevens/1.png'),
            require('../images/games/cosmic-sevens/2.png'),
            require('../images/games/cosmic-sevens/3.png'),
        ],
        url: 'https://static.redstone.rs/games/cosmic-sevens/',
    },
    'funky-fruits': {
        name: 'Funky Fruits',
        desc: 'In Funky Fruits, every spin brings a fresh chance to win big. Get ready for wild, colorful fruits that keep the game exciting and the rewards rolling in.',
        features: [
            '5 Lines',
            '5x3',
            'Expanding Symbol',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/funky-fruits/0.png'),
            require('../images/games/funky-fruits/1.png'),
            require('../images/games/funky-fruits/2.png'),
            require('../images/games/funky-fruits/3.png'),
        ],
        url: 'https://static.redstone.rs/games/funky-fruits/',
    },
    'christmas-delight': {
        name: 'Christmas Delight',
        desc: 'With Christmas Delight, the reels are stacked with festive fruit and exciting wins. Let the season’s celebrations begin!',
        features: [
            '5 Lines',
            '5x3',
            'Win Multiplier',
            'Two expanding wilds',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/christmas-delight/0.png'),
            require('../images/games/christmas-delight/1.png'),
            require('../images/games/christmas-delight/2.png'),
            require('../images/games/christmas-delight/3.png'),
        ],
        url: 'https://static.redstone.rs/games/christmas-delight/',
    },
    'juicy-heat-20': {
        name: 'Juicy Heat 20',
        desc: 'Juicy Heat 20: More Fruits, More Wins! Line up 5 matching fruits for a 5x multiplier! The more fruit you line up, the hotter the win! Play now for sizzling rewards!',
        features: [
            '20 Lines',
            '5x3',
            'Win Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/juicy-heat-20/0.png'),
            require('../images/games/juicy-heat-20/1.png'),
            require('../images/games/juicy-heat-20/2.png'),
            require('../images/games/juicy-heat-20/3.png'),
        ],
        url: 'https://static.redstone.rs/games/juicy-heat-20/',
    },
    '27-double-fruits': {
        name: '27 Double Fruits',
        desc: '27 Double Fruits spices up classic gameplay by doubling your rewards when all symbols align. Fill the reels with matching fruits and enjoy the sweet x2 multiplier on every perfect spin!',
        features: [
            '27 Ways',
            '3x3',
            'Win Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/27-double-fruits/0.png'),
            require('../images/games/27-double-fruits/1.png'),
            require('../images/games/27-double-fruits/2.png'),
            require('../images/games/27-double-fruits/3.png'),
        ],
        url: 'https://static.redstone.rs/games/27-double-fruits/',
    },
    'only-anime': {
        name: 'Only Anime',
        desc: 'Only Anime brings the charm of anime and thrilling action together in one slot. Spin the reels for a chance at exciting rewards and enjoy an adventure packed with style.',
        features: [
            'Expanding wild',
            '5x3',
            '5 Lines',
            'Two Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/only-anime/0.png'),
            require('../images/games/only-anime/1.png'),
            require('../images/games/only-anime/2.png'),
            require('../images/games/only-anime/3.png'),
        ],
        url: 'https://static.redstone.rs/games/only-anime/',
    },
    '10-clover-fire': {
        name: '10 Clover Fire',
        desc: 'Expanding Wilds to boost winning potential. 10 Clover Fire is swift and fiery, and getting Clovers on the central 3 reels ignites massive wins.',
        features: [
            'Expanding wild',
            '10 lines',
            'Two Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-clover-fire/0.png'),
            require('../images/games/10-clover-fire/1.png'),
            require('../images/games/10-clover-fire/2.png'),
            require('../images/games/10-clover-fire/3.png'),
        ],
        url: 'https://static.redstone.rs/games/10-clover-fire/',
    },
    '81-double-magic': {
        name: '81 Double Magic',
        desc: 'Discover the thrill of 81 Double Magic! With 81 ways to win and a Mystery Scatter feature, this classc slot offers endlesscexcitement and big rewards. Spin now and let the magic unfold!',
        features: [
            '81 Ways',
            '4x3',
            'Win Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/81-double-magic/0.png'),
            require('../images/games/81-double-magic/1.png'),
            require('../images/games/81-double-magic/2.png'),
            require('../images/games/81-double-magic/3.png'),
        ],
        url: 'https://static.redstone.rs/games/81-double-magic/',
    },
    'spooky-spins': {
        name: 'Spooky Spins',
        desc: 'Get ready for a frightful adventure in Spooky Spins! This Halloween slot is packed with haunted reels, wickedly fun features and a chance to win over x20000+ your bet! Spin if you dare - spooky rewards are just waiting to be claimed!',
        features: [
            '10 Lines',
            'Expanding Wild',
            'Bonus',
            'Bonus Feature',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/spooky-spins/0.png'),
            require('../images/games/spooky-spins/1.png'),
            require('../images/games/spooky-spins/2.png'),
            require('../images/games/spooky-spins/3.png'),
            require('../images/games/spooky-spins/4.png'),
        ],
        url: 'https://static.redstone.rs/games/spooky-spins/',
        bg: require('../images/games/spooky-spins/bg.png'),
    },
    '5-wild-fire': {
        name: '5 Wild Fire',
        desc: 'Experience the classic fun of 5 Wild Fire! Set all five reels on fire for a chance to multiply your stake by an incredible x2000! Ready to play?',
        features: [
            '5 Lines',
            'Expanding Wild',
            '5x3',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-wild-fire/0.png'),
            require('../images/games/5-wild-fire/1.png'),
            require('../images/games/5-wild-fire/2.png'),
            require('../images/games/5-wild-fire/3.png'),
        ],
        url: 'https://static.redstone.rs/games/5-wild-fire/',
    },
    'volcano-hot': {
        name: 'Volcano Hot',
        desc: `Get ready for a lava-hot adventure with Volcano Hot! Stacked wilds and scatter symbols add excitement to every spin, offering a chance to win big!`,
        features: [
            'Wild Symbol',
            'Classic Mechanics',
            '20 lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/volcano-hot/0.png'),
            require('../images/games/volcano-hot/1.png'),
            require('../images/games/volcano-hot/2.png'),
            require('../images/games/volcano-hot/3.png'),
        ],
        url: 'https://static.redstone.rs/games/volcano-hot/',
    },
    'volcano-crown': {
        name: 'Volcano Crown',
        desc: `Feel the lava flow as you spin for regal rewards. Erupt with excitement and claim your Volcano Crown today!`,
        features: [
            'Expanding wild',
            '2 Scatter Symbols',
            '10 lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/volcano-crown/0.png'),
            require('../images/games/volcano-crown/1.png'),
            require('../images/games/volcano-crown/2.png'),
            require('../images/games/volcano-crown/3.png'),
        ],
        url: 'https://static.redstone.rs/games/volcano-crown/',
    },
    '100-clover-fire': {
        name: '100 Clover Fire',
        desc: `100 Clover Fire means 100 ways to win! Feel the thrill, spin the reels, and blaze your path to massive wins!`,
        features: [
            'Expanding wild',
            '100 Lines',
            'Scatter Symbol',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/100-clover-fire/0.png'),
            require('../images/games/100-clover-fire/1.png'),
            require('../images/games/100-clover-fire/2.png'),
            require('../images/games/100-clover-fire/3.png'),
        ],
        url: 'https://static.redstone.rs/games/100-clover-fire/',
    },
    'dice-double': {
        name: 'Dice Double',
        desc: `Dive into Dice Double, the new slot game that doubles your excitement! Land on the middle reel with a double expanding symbol and watch your wins double, making every spin a thrilling experience.`,
        features: [
            'Two expand symbols',
            '5 Lines',
            'Scatter Symbol',
            'Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/dice-double/0.png'),
            require('../images/games/dice-double/1.png'),
            require('../images/games/dice-double/2.png'),
            require('../images/games/dice-double/3.png'),
        ],
        url: 'https://static.redstone.rs/games/dice-double/',
    },
    'double-clover-fire': {
        name: 'Double Clover Fire',
        desc: `Discover the blazing excitement of Double Clover Fire and spin your way to
        doubled wins today!`,
        features: [
            'Two expand symbols',
            '5 Lines',
            'Scatter Symbol',
            'Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/double-clover-fire/0.png'),
            require('../images/games/double-clover-fire/1.png'),
            require('../images/games/double-clover-fire/2.png'),
            require('../images/games/double-clover-fire/3.png'),
        ],
        url: 'https://static.redstone.rs/games/double-clover-fire/',
    },
    'spin-up': {
        name: 'Spin Up',
        desc: `Get ready to Spin Up and experience nostalgic vibes! Let the five ladies spark up your reels and bring big wins up to x2000! It's time to spin, win big and relive those classic vibes!`,
        features: [
            'Expanding wild',
            '5x3',
            '5 Lines',
            'Two Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/spin-up/0.png'),
            require('../images/games/spin-up/1.png'),
            require('../images/games/spin-up/2.png'),
            require('../images/games/spin-up/3.png'),
        ],
        url: 'https://static.redstone.rs/games/spin-up/',
    },
    '81-vegas-crown': {
        name: '81 Vegas Crown',
        desc: 'Feel the Vegas atmosphere with 81 Vegas Crown, land crown symbols and get some juicy multipliers!',
        features: [
            '81 Ways',
            '4x3',
            'Win Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/81-vegas-crown/0.png'),
            require('../images/games/81-vegas-crown/1.png'),
            require('../images/games/81-vegas-crown/2.png'),
            require('../images/games/81-vegas-crown/3.png'),
        ],
        url: 'https://static.redstone.rs/games/81-vegas-crown/',
    },
    'apollo-27-classic': {
        name: 'Apollo 27 Classic',
        desc: 'Spin the fruity reels and chase double wins! With 27 ways for payout, this game is a juicy classic! Experience the fun and excitement as you spin your way to amazing rewards.',
        features: [
            '27 Ways',
            '3x3',
            'Win Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/apollo-27-classic/0.png'),
            require('../images/games/apollo-27-classic/1.png'),
            require('../images/games/apollo-27-classic/2.png'),
            require('../images/games/apollo-27-classic/3.png'),
        ],
        url: 'https://static.redstone.rs/games/apollo-27-classic/',
    },
    'hot-rush-fruit-lines': {
        name: 'HOT RUSH Fruit Lines',
        desc: 'Introducing Fruit Lines, your ticket to classic slot excitement! Spin the reels and line up your favorite fruits for a taste of sweet winnings.',
        features: [
            'Classic mechanics',
            '5x3',
            '5 Lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/hot-rush-fruit-lines/0.png'),
            require('../images/games/hot-rush-fruit-lines/1.png'),
            require('../images/games/hot-rush-fruit-lines/2.png'),
            require('../images/games/hot-rush-fruit-lines/3.png'),
        ],
        url: 'https://static.redstone.rs/games/hot-rush-fruit-lines/',
    },
    'book-of-scorpio': {
        name: 'Book Of Scorpio',
        desc: 'Discover ancient secrets in this thrilling slot! Trigger the bonus round with 3 books to reveal 2 expanding symbols for epic wins. Explore the secrets of Scorpio and claim your riches!',
        features: [
            'Bonus',
            'Two Expanding Symbols',
            'Book Mechanics'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/book-of-scorpio/0.png'),
            require('../images/games/book-of-scorpio/1.png'),
            require('../images/games/book-of-scorpio/2.png'),
            require('../images/games/book-of-scorpio/3.png'),
        ],
        url: 'https://static.redstone.rs/games/book-of-scorpio/',
    },
    'hot-rush-both-ways': {
        name: 'HOT RUSH Both Ways',
        desc: 'Get a taste of double delight in our HOT RUSH Both Ways! Win from left to right and right to left for double the chances to win big! Easy to play, impossible to resist. Start spinning now!',
        features: [
            'Bothways',
            '5 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/hot-rush-both-ways/0.png'),
            require('../images/games/hot-rush-both-ways/1.png'),
            require('../images/games/hot-rush-both-ways/2.png'),
            require('../images/games/hot-rush-both-ways/3.png'),
        ],
        url: 'https://static.redstone.rs/games/hot-rush-both-ways/',
    },
    'caps-and-crowns': {
        name: 'Caps and Crowns',
        desc: 'Cross the royal threshold with Caps and Crowns, and hit it big where caps and crowns boost your spins for wins up to 2600x!',
        features: [
            'Two expand symbols',
            '5 Lines',
            'Scatter Symbol',
            'Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/caps-and-crowns/0.png'),
            require('../images/games/caps-and-crowns/1.png'),
            require('../images/games/caps-and-crowns/2.png'),
            require('../images/games/caps-and-crowns/3.png'),
        ],
        url: 'https://static.redstone.rs/games/caps-and-crowns/',
    },
    '5-clover-fire-lnc': {
        name: '5 Clover Fire Lock & Cash',
        desc: 'Spin, lock, and watch your luck bloom with 5 Clover Fire - Lock & Cash: Unleash the power of the clover Wild symbol across 5 lines, turning each spin into a cash-filled delight.',
        features: [
            '5 Lines',
            'Lock & Cash',
            'Bonus',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-clover-fire-lnc/0.png'),
            require('../images/games/5-clover-fire-lnc/1.png'),
            require('../images/games/5-clover-fire-lnc/2.png'),
            require('../images/games/5-clover-fire-lnc/3.png'),
        ],
        url: 'https://static.redstone.rs/games/5-clover-fire-lnc/',
    },
    'hot-rush-stars-deluxe': {
        name: 'HOT RUSH Stars Deluxe',
        desc: 'Step into the world of HOT RUSH: Stars Deluxe, where simplicity meets excitement! With just 5 lines, this classic game ensures a journey packed with wins, elevating the thrill with each spin.',
        features: [
            '5 Lines',
            'Scatter Symbol',
            'Classic Mechanics',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/hot-rush-stars-deluxe/0.png'),
            require('../images/games/hot-rush-stars-deluxe/1.png'),
            require('../images/games/hot-rush-stars-deluxe/2.png'),
            require('../images/games/hot-rush-stars-deluxe/3.png'),
        ],
        url: 'https://static.redstone.rs/games/hot-rush-stars-deluxe/',
    },
    'slot-royale': {
        name: 'Slot Royale',
        desc: 'Experience the elegance of Slot Royale with every spin, revealing exciting wins up to x1500! Enjoy gleaming fruits and a majestic crown in this timeless slot game.',
        features: [
            '10 Lines',
            'Expanding Wild Symbol',
            'Scatter Symbols',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/slot-royale/0.png'),
            require('../images/games/slot-royale/1.png'),
            require('../images/games/slot-royale/2.png'),
            require('../images/games/slot-royale/3.png'),
        ],
        url: 'https://static.redstone.rs/games/slot-royale/',
    },
    'lady-triple-fortune': {
        name: 'Lady Triple Fortune',
        desc: 'Unlock the fortunes in Lady Triple Fortune, where every expanding wild boosts your chances at an incredible 1200x win!',
        features: [
            '5 Lines',
            'Expanding Wild Symbol',
            'Scatter Symbols',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/lady-triple-fortune/0.png'),
            require('../images/games/lady-triple-fortune/1.png'),
            require('../images/games/lady-triple-fortune/2.png'),
            require('../images/games/lady-triple-fortune/3.png'),
        ],
        url: 'https://static.redstone.rs/games/lady-triple-fortune/',
    },
    'hot-rush-crown-burst': {
        name: 'HOT RUSH Crown Burst',
        desc: 'In HOT RUSH: Crown Burst, every expanding wild brings a rush of adrenaline and the chance for a 1200x cosmic payout!',
        features: [
            '5 Lines',
            'Expanding Wild Symbol',
            'Scatter Symbols',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/hot-rush-crown-burst/0.png'),
            require('../images/games/hot-rush-crown-burst/1.png'),
            require('../images/games/hot-rush-crown-burst/2.png'),
            require('../images/games/hot-rush-crown-burst/3.png'),
        ],
        url: 'https://static.redstone.rs/games/hot-rush-crown-burst/',
    },
    'chilli-double': {
        name: 'Chilli Double',
        desc: 'Feel the heat, embrace the thrill, and let the Chilli Double bring the flavor of big wins with expanding wild 2x multiplier!',
        features: [
            '5 Lines',
            'Expanding Wild Symbol',
            'Multiplier',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/chilli-double/0.png'),
            require('../images/games/chilli-double/1.png'),
            require('../images/games/chilli-double/2.png'),
            require('../images/games/chilli-double/3.png'),
        ],
        url: 'https://static.redstone.rs/games/chilli-double/',
    },
    'jolly-presents': {
        name: 'Jolly Presents',
        desc: 'Get wrapped up in the fun of Jolly Presents, where expanding wilds mean big wins up to x1200! Holiday joy is just a spin away!',
        features: [
            '5 Lines',
            'Expanding Wild Symbol',
            'Scatter Symbols',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/jolly-presents/0.png'),
            require('../images/games/jolly-presents/1.png'),
            require('../images/games/jolly-presents/2.png'),
            require('../images/games/jolly-presents/3.png'),
        ],
        url: 'https://static.redstone.rs/games/jolly-presents/',
        bg: require('../images/games/10-wild-santa/bg.png'),
    },
    '20-wild-crown': {
        name: '20 Wild Crown',
        desc: `Experience the thrill of expanding wilds. It's all in the spin!`,
        features: [
            '20 Lines',
            'Expanding Wild Symbol',
            '2 Scatter Symbols',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/20-wild-crown/0.png'),
            require('../images/games/20-wild-crown/1.png'),
            require('../images/games/20-wild-crown/2.png'),
            require('../images/games/20-wild-crown/3.png'),
        ],
        url: 'https://static.redstone.rs/games/20-wild-crown/',
    },
    '40-jokers-free-games': {
        name: '40 Jokers Free Games',
        desc: 'Stack wild Jokers and chase free games in a game of chance and luck!',
        features: [
            '40 Lines',
            'Stacked Wild Symbol',
            'Free Games',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-jokers-free-games/0.png'),
            require('../images/games/40-jokers-free-games/1.png'),
            require('../images/games/40-jokers-free-games/2.png'),
            require('../images/games/40-jokers-free-games/3.png'),
        ],
        url: 'https://static.redstone.rs/games/40-jokers-free-games/',
    },
    'moon-dog': {
        name: 'Moon Dog',
        desc: 'Explore the Moon Dog universe, the ultimate playground!',
        features: [
            '40 Lines',
            'Stacked Wild Symbol',
            'Free Games',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/moon-dog/0.png'),
            require('../images/games/moon-dog/1.png'),
            require('../images/games/moon-dog/2.png'),
            require('../images/games/moon-dog/3.png'),
        ],
        url: 'https://static.redstone.rs/games/moon-dog/',
    },
    'wild-trail': {
        name: 'Wild Trail',
        desc: 'Set off on a Wild Trail adventure across 40 lines with thrilling bonus games, and get a chance to win up to 2000x your stake!',
        features: [
            '40 Lines',
            'Stacked Wild Symbol',
            'Free Games',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/wild-trail/0.png'),
            require('../images/games/wild-trail/1.png'),
            require('../images/games/wild-trail/2.png'),
            require('../images/games/wild-trail/3.png'),
        ],
        url: 'https://static.redstone.rs/games/wild-trail/',
    },
    'wild-heart-beat': {
        name: 'Wild HEART Beat',
        desc: 'Wild HEART Beat sets the rhythm for big wins, with expanding wilds that could lead to a heart-stopping 2000x payout!',
        features: [
            '5 Lines',
            'Expanding Wild Symbol',
            'Scatter Symbols',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/wild-heart-beat/0.png'),
            require('../images/games/wild-heart-beat/1.png'),
            require('../images/games/wild-heart-beat/2.png'),
            require('../images/games/wild-heart-beat/3.png'),
        ],
        url: 'https://static.redstone.rs/games/wild-heart-beat/',
    },
    '40-fruit-frenzy': {
        name: '40 Fruit Frenzy',
        desc: 'New adventure awaits! Fruit Frenzy is stacked with 40 lines and offers frenzied wins that can rack up huge rewards.',
        features: [
            '40 Lines',
            'Wild Symbol',
            'Scatter Symbol',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-fruit-frenzy/0.png'),
            require('../images/games/40-fruit-frenzy/1.png'),
            require('../images/games/40-fruit-frenzy/2.png'),
            require('../images/games/40-fruit-frenzy/3.png'),
        ],
        url: 'https://static.redstone.rs/games/40-fruit-frenzy/',
    },
    '20-fruit-frenzy': {
        name: '20 Fruit Frenzy',
        desc: 'Get ready for some juicy fruits. Fruit Frenzy, with its 20 lines, offers high rewards, with some wins that can go up to 1,000x.',
        features: [
            '20 Lines',
            'Wild Symbol',
            'Scatter Symbol',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/20-fruit-frenzy/0.png'),
            require('../images/games/20-fruit-frenzy/1.png'),
            require('../images/games/20-fruit-frenzy/2.png'),
            require('../images/games/20-fruit-frenzy/3.png'),
        ],
        url: 'https://static.redstone.rs/games/20-fruit-frenzy/',
    },
    'chilli-hot-5': {
        name: 'Chilli Hot 5',
        desc: 'Spice it up with Chilli Hot 5 for fiery wins up to 1200x. Chilli Wilds expand across the middle three reels for maximum hotness!',
        features: [
            '5 Lines',
            'Expanding Wild',
            'Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/chilli-hot-5/0.png'),
            require('../images/games/chilli-hot-5/1.png'),
            require('../images/games/chilli-hot-5/2.png'),
            require('../images/games/chilli-hot-5/3.png'),
        ],
        url: 'https://static.redstone.rs/games/chilli-hot-5/',
    },
    '40-hot-joker': {
        name: '40 Hot Joker',
        desc: 'It’s getting hot in here! Get lucky with Hot Joker wilds, expanding across the middle 3 reels for massive wins on 40 lines and up to 3000x!',
        features: [
            '40 Lines',
            'Expanding Wild',
            'Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-hot-joker/0.png'),
            require('../images/games/40-hot-joker/1.png'),
            require('../images/games/40-hot-joker/2.png'),
            require('../images/games/40-hot-joker/3.png'),
        ],
        url: 'https://static.redstone.rs/games/40-hot-joker/',
    },
    'fear-of-dark': {
        name: 'Fear of Dark',
        desc: 'Face Fear of Dark and win up to skin crawling 3000x!',
        features: [
            '40 Lines',
            'Expanding Wild',
            'Scatters',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/fear-of-dark/0.png'),
            require('../images/games/fear-of-dark/1.png'),
            require('../images/games/fear-of-dark/2.png'),
            require('../images/games/fear-of-dark/3.png'),
        ],
        url: 'https://static.redstone.rs/games/fear-of-dark/',
    },
    'clover-blast-5': {
        name: 'Clover Blast 5',
        desc: 'Give Clover Blast 5 a spin. Hit 5 clovers and you could win up to 2000x your bet.',
        features: [
            '5 Lines',
            'Expanding Wild',
            '5x3',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/clover-blast-5/0.png'),
            require('../images/games/clover-blast-5/1.png'),
            require('../images/games/clover-blast-5/2.png'),
            require('../images/games/clover-blast-5/3.png'),
            require('../images/games/clover-blast-5/4.png'),
        ],
        url: 'https://static.redstone.rs/games/clover-blast-5/',
    },
    'hot-hot': {
        name: 'Hot Hot Stereo Win',
        desc: 'Hot Hot, where fiery lava rivers meet blazing opportunities, promises a gaming experience that sparks winnings in both directions.',
        features: [
            '5 Lines',
            'Bothways',
            '5x3',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/hot-hot/0.png'),
            require('../images/games/hot-hot/1.png'),
            require('../images/games/hot-hot/2.png'),
            require('../images/games/hot-hot/3.png'),
        ],
        url: 'https://static.redstone.rs/games/hot-hot/',
    },
    'blazing-heat': {
        name: 'Blazing HEAT',
        desc: 'Step into the world of Blazing HEAT. Every win boosts your gameplay, adding a layer of excitement to your journey for rewards.',
        features: [
            '5 Lines',
            'Classic Mechanics',
            'Scatter',
            '5x3',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/blazing-heat/0.png'),
            require('../images/games/blazing-heat/1.png'),
            require('../images/games/blazing-heat/2.png'),
            require('../images/games/blazing-heat/3.png'),
        ],
        url: 'https://static.redstone.rs/games/blazing-heat/',
    },
    'heat-double': {
        name: 'HEAT Double',
        desc: 'Experience the fiery fun of HEAT Double, where filling all reels with the same fruit symbol rewards you with a 2x multiplier! Dive into this fruit-themed slot and enjoy a delicious gaming experience.',
        features: [
            '5 Lines',
            'Win Multiplier',
            '3x3',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/heat-double/0.png'),
            require('../images/games/heat-double/1.png'),
            require('../images/games/heat-double/2.png'),
            require('../images/games/heat-double/3.png'),
        ],
        url: 'https://static.redstone.rs/games/heat-double/',
    },
    'super-lucky': {
        name: 'Super Lucky',
        desc: 'Looking for some excitement? Super Lucky has got you covered! With its thrilling Lock and Cash features, every spin is a chance to strike it big.',
        features: [
            '5 Lines',
            'Lock&Cash Bonus',
            'GRAND Prize',
            'Wild Symbol',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/super-lucky/0.png'),
            require('../images/games/super-lucky/1.png'),
            require('../images/games/super-lucky/2.png'),
            require('../images/games/super-lucky/3.png'),
            require('../images/games/super-lucky/4.png'),

        ],
        url: 'https://static.redstone.rs/games/super-lucky/',
    },
    '40-fire-cash': {
        name: '40 Fire Cash',
        desc: 'Step back in time and enjoy retro design of this hot fruit slot game. Immerse yourself in the excitement and try your luck to win big today!',
        features: [
            'Scatter Symbol',
            'Wild Symbol',
            '40 Lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-fire-cash/0.png'),
            require('../images/games/40-fire-cash/1.png'),
            require('../images/games/40-fire-cash/2.png'),
            require('../images/games/40-fire-cash/3.png'),
        ],
        url: 'https://static.redstone.rs/games/40-fire-cash/',
    },
    '20-fire-cash': {
        name: '20 Fire Cash',
        desc: 'With classic mechanics and retro design, this game will transport you back in time. Try your luck and spin to win today!',
        features: [
            'Scatter Symbol',
            'Wild Symbol',
            '20 Lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/20-fire-cash/0.png'),
            require('../images/games/20-fire-cash/1.png'),
            require('../images/games/20-fire-cash/2.png'),
            require('../images/games/20-fire-cash/3.png'),
        ],
        url: 'https://static.redstone.rs/games/20-fire-cash/',
    },
    '10-wild-santa': {
        name: '10 Wild Santa',
        desc: 'Santa came early this year. Enjoy the generous wins and exciting features of expanding Santa in 5x3 reel slot game and grab your Christmas gifts. You deserve it!',
        features: [
            'Expanding Wild',
            '2 Scatters',
            '10 Lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-wild-santa/0.png'),
            require('../images/games/10-wild-santa/1.png'),
            require('../images/games/10-wild-santa/2.png'),
            require('../images/games/10-wild-santa/3.png'),
            require('../images/games/10-wild-santa/4.png'),
        ],
        url: 'https://static.redstone.rs/games/10-wild-santa/',
        bg: require('../images/games/10-wild-santa/bg.png'),
    },
    '5-crown-fire': {
        name: '5 Crown Fire',
        desc: 'Royal games give royal wins! Find your lucky crowns and feel the power of fruits with new 5 lined game!',
        features: [
            'Expanding Wild',
            '2 Scatters',
            '10 Lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-crown-fire/0.png'),
            require('../images/games/5-crown-fire/1.png'),
            require('../images/games/5-crown-fire/2.png'),
            require('../images/games/5-crown-fire/3.png'),
        ],
        url: 'https://static.redstone.rs/games/5-crown-fire/',
    },
    'heat-classic-5': {
        name: 'HEAT Classic 5',
        desc: 'Fire up the reels and feel the heat of winning big! HEAT Classic 5 is a future timeless classic with the perfect blend of retro mechanics and modern looks.',
        features: [
            'Classic Slot',
            '3x3',
            '5 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/heat-classic-5/0.png'),
            require('../images/games/heat-classic-5/1.png'),
            require('../images/games/heat-classic-5/2.png'),
            require('../images/games/heat-classic-5/3.png'),
        ],
        url: 'https://static.redstone.rs/games/heat-classic-5/',
    },
    'book-of-dread': {
        name: 'Book of Dread',
        desc: 'Leave your fears behind. Collect 3 or more books and step into the world of darkness. The amount you can win is TERRIFYING!',
        features: [
            'Book Mechanics',
            'Two Bonus Symbols',
            '10 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/book-of-dread/0.png'),
            require('../images/games/book-of-dread/1.png'),
            require('../images/games/book-of-dread/2.png'),
            require('../images/games/book-of-dread/3.png'),
            require('../images/games/book-of-dread/4.png'),
        ],
        url: 'https://static.redstone.rs/games/book-of-dread/',
        bg: require('../images/games/book-of-dread/bg.png'),
    },
    '10-wild-pumpkin': {
        name: '10 Wild Pumpkin',
        desc: '’Tis the spooky season! Land up to 3 expanding Wild Pumpkins for massive wins on up to 10 lines.',
        features: [
            'Expanding Wild',
            'Two Scatters',
            '10 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-wild-pumpkin/0.jpg'),
            require('../images/games/10-wild-pumpkin/1.jpg'),
            require('../images/games/10-wild-pumpkin/2.jpg'),
            require('../images/games/10-wild-pumpkin/3.jpg'),
        ],
        url: 'https://static.redstone.rs/games/10-wild-pumpkin/',
        bg: require('../images/games/10-wild-pumpkin/bg.png'),
    },
    'clover-coin': {
        name: 'Clover Coin',
        desc: 'Classic feel, juicy fruits and lucky clovers! Collect 6 or more Clover Coins to trigger Lock&Cash Bonus feature where you can score GRAND Bonus prize by collecting all 15 coins.',
        features: [
            'Lock&Cash Bonus',
            'GRAND Prize',
            'Wild Symbol',
            '10 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/clover-coin/0.jpg'),
            require('../images/games/clover-coin/1.jpg'),
            require('../images/games/clover-coin/2.jpg'),
            require('../images/games/clover-coin/3.jpg'),
            require('../images/games/clover-coin/4.jpg'),
        ],
        url: 'https://static.redstone.rs/games/clover-coin/'
    },
    '10-wild-dice': {
        name: '10 Wild Dice',
        desc: 'Roll the dice and feel the heat of victory, get expanding WILD symbol and increase your chance to win huge!',
        features: [
            'Expanding Wild',
            '2 Scatters',
            '10 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-wild-dice/0.jpg'),
            require('../images/games/10-wild-dice/1.jpg'),
            require('../images/games/10-wild-dice/2.jpg'),
            require('../images/games/10-wild-dice/3.jpg'),
            require('../images/games/10-wild-dice/4.jpg'),
        ],
        url: 'https://static.redstone.rs/games/10-wild-dice/'
    },
    'mayan-coins': {
        name: 'Mayan Coins',
        desc: 'Discover Ancient world of Maya. Seek the thrill and win exotic riches by collecting Mayan Coins. 6 coins trigger Lock&Cash bonus in which you can score GRAND prize by collecting all 15 coins.',
        features: [
            'Lock&Cash Bonus',
            'GRAND Prize',
            'Wild Symbol',
            '10 Lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/mayan-coins/0.jpg'),
            require('../images/games/mayan-coins/1.jpg'),
            require('../images/games/mayan-coins/2.jpg'),
            require('../images/games/mayan-coins/3.jpg'),
            require('../images/games/mayan-coins/4.jpg'),
        ],
        url: 'https://static.redstone.rs/games/mayan-coins/'
    },
    '10-wild-crown': {
        name: '10 Wild Crown',
        desc: 'Hot and explosive experience. Conquer luck and land up to 3 Expanding Wilds for massive wins. The Crown is yours!',
        features: [
            'Expanding Wild',
            '2 Scatters',
            '10 Lines'
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-wild-crown/0.jpg'),
            require('../images/games/10-wild-crown/1.jpg'),
            require('../images/games/10-wild-crown/2.jpg'),
            require('../images/games/10-wild-crown/3.jpg'),
        ],
        url: 'https://static.redstone.rs/games/10-wild-crown/'
    },
    '40-cash-bells': {
        name: '40 Cash Bells',
        desc: 'The nostalgic adventure to shoot you back in time. 40 Cash Bells is a retro classic that features stacked fruits and free spins. Ring the bells of victory!',
        features: [
            'Free Spins',
            'Stacked Wilds',
            '40 Lines',
            '6 Reels',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-cash-bells/0.jpg'),
            require('../images/games/40-cash-bells/1.jpg'),
            require('../images/games/40-cash-bells/2.jpg'),
            require('../images/games/40-cash-bells/3.jpg'),
            require('../images/games/40-cash-bells/4.jpg'),
        ],
        url: 'https://static.redstone.rs/games/40-cash-bells/',
    },
    '40-clover-fire': {
        name: '40 Clover Fire',
        desc: 'Expanding Wilds and 40 lines for maximum chance to win. 40 Clover Fire is fast and explosive, and landing Clovers in middle 3 reels will light up big wins.',
        features: [
            'Expanding Wild',
            '2 Scatters',
            '40 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-clover-fire/0.jpg'),
            require('../images/games/40-clover-fire/1.jpg'),
            require('../images/games/40-clover-fire/2.jpg'),
            require('../images/games/40-clover-fire/3.jpg'),
        ],
        url: 'https://static.redstone.rs/games/40-clover-fire/'
    },
    'action-hot-20': {
        name: 'Action Hot 20',
        desc: 'Get ready for some hot action! Action Hot 20 is simple and fast but highly rewarding with fiery combos of stacked symbols that can rake up huge super wins.',
        features: [
            'Stacked Symbols',
            'Scatter',
            '20 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/action-hot-20/0.jpg'),
            require('../images/games/action-hot-20/1.jpg'),
            require('../images/games/action-hot-20/2.jpg'),
            require('../images/games/action-hot-20/3.jpg'),
        ],
        url: 'https://static.redstone.rs/games/action-hot-20/'
    },
    'lost-book': {
        name: 'Lost Book',
        desc: 'The Ancient Egyptian riches await the brave. Journey to the mysterious Queen\'s chambers and if you\'re lucky enough she will reward mightily.',
        features: [
            'Free Spins',
            'Expanding Special Symbol',
            'Book Mechanics',
            '10 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/lost-book/0.jpg'),
            require('../images/games/lost-book/1.jpg'),
            require('../images/games/lost-book/2.jpg'),
            require('../images/games/lost-book/3.jpg'),
            require('../images/games/lost-book/4.jpg'),
        ],
        url: 'https://static.redstone.rs/games/lost-book/'
    },
    '5-wild-heart': {
        name: '5 Wild Heart',
        desc: 'Explosive Wild wins that get your heart pumping! Whether lucky 7\'s, bells or juicy fruits, stacking them up next to Expanding Wilds will get you massive pay.',
        features: [
            'Expanding Wild',
            '2 Scatters',
            '5 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-wild-heart/0.jpg'),
            require('../images/games/5-wild-heart/1.jpg'),
            require('../images/games/5-wild-heart/2.jpg'),
            require('../images/games/5-wild-heart/3.jpg'),
        ],
        url: 'https://static.redstone.rs/games/5-wild-heart/'
    },
    '40-dice-fire': {
        name: '40 Dice Fire',
        desc: 'Roll the Dice and be an instant winner! Dice variant slot with 40 lines brings colorful wins with Expanding Wilds on reels 2, 3 and 4.',
        features: [
            'Expanding Wild',
            '2 Scatters',
            '40 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-dice-fire/0.jpg'),
            require('../images/games/40-dice-fire/1.jpg'),
            require('../images/games/40-dice-fire/2.jpg'),
            require('../images/games/40-dice-fire/3.jpg'),
        ],
        url: 'https://static.redstone.rs/games/40-dice-fire/'
    },
    '10-wild-diamond': {
        name: '10 Wild Diamond',
        desc: 'REDSTONE Diamonds are forever! Fire up all 9 expanded Diamonds and get blazing super win going. A classic in the making, 10 Wild Diamond is thrilling, fast and unforgettable.',
        features: [
            'Expanding Wild',
            '2 Scatters',
            '10 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/10-wild-diamond/0.jpg'),
            require('../images/games/10-wild-diamond/1.jpg'),
            require('../images/games/10-wild-diamond/2.jpg'),
            require('../images/games/10-wild-diamond/3.jpg'),
        ],
        url: 'https://static.redstone.rs/games/10-wild-diamond/'
    },
    'action-hot-40': {
        name: 'Action Hot 40',
        desc: 'Get ready for some hot action! Action Hot 40 is simple and fast but highly rewarding with fiery combos of stacked symbols that can rake up huge super wins.',
        features: [
            'Stacked Symbols',
            'Scatter',
            '40 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/action-hot-40/0.jpg'),
            require('../images/games/action-hot-40/1.jpg'),
            require('../images/games/action-hot-40/2.jpg'),
            require('../images/games/action-hot-40/3.jpg'),
        ],
        url: 'https://static.redstone.rs/games/action-hot-40/'
    },
    '5-clover-fire': {
        name: '5 Clover Fire',
        desc: 'Expanding Wilds for maximum chance to win. 5 Clover Fire is fast and explosive, and landing Clovers in middle 3 reels will light up big wins.',
        features: [
            'Expanding Wild',
            '2 Scatters',
            '5 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-clover-fire/0.jpg'),
            require('../images/games/5-clover-fire/1.jpg'),
            require('../images/games/5-clover-fire/2.jpg'),
            require('../images/games/5-clover-fire/3.jpg'),
        ],
        url: 'https://static.redstone.rs/games/5-clover-fire/'
    },
    '5-dice-fire': {
        name: '5 Dice Fire',
        desc: 'Roll the Dice and be an instant winner! Dice variant slot with 5 lines brings colorful wins with Expanding Wilds on reels 2, 3 and 4.',
        features: [
            'Expanding Wild',
            '2 Scatters',
            '5 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/5-dice-fire/0.jpg'),
            require('../images/games/5-dice-fire/1.jpg'),
            require('../images/games/5-dice-fire/2.jpg'),
            require('../images/games/5-dice-fire/3.jpg'),
        ],
        url: 'https://static.redstone.rs/games/5-dice-fire/'
    },
    '50-wild-cash': {
        name: '50 Wild Cash',
        desc: 'Wild Pots full of gold! With a little bit of luck you can land full reels of stacked Wild Pots for massive wins. Free Games symbols trigger Free Spins feature.',
        features: [
            'Stacked Wilds',
            'Free Spins',
            '50 Lines',
            '6 Reels',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/50-wild-cash/0.jpg'),
            require('../images/games/50-wild-cash/1.jpg'),
            require('../images/games/50-wild-cash/2.jpg'),
            require('../images/games/50-wild-cash/3.jpg'),
            require('../images/games/50-wild-cash/4.jpg'),
        ],
        url: 'https://static.redstone.rs/games/50-wild-cash/'
    },
    '40-wild-dice': {
        name: '40 Wild Dice',
        desc: 'Roll the Wild Dice! Score massive wins with stacked dice symbols, and if that is not enough get 3 or more Free Games symbols to score Free Spins feature.',
        features: [
            'Stacked Wilds',
            'Free Spins',
            '40 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-wild-dice/0.jpg'),
            require('../images/games/40-wild-dice/1.jpg'),
            require('../images/games/40-wild-dice/2.jpg'),
            require('../images/games/40-wild-dice/3.jpg'),
            require('../images/games/40-wild-dice/4.jpg'),
        ],
        url: 'https://static.redstone.rs/games/40-wild-dice/'
    },
    '40-wild-clover': {
        name: '40 Wild Clover',
        desc: 'This is your lucky Clover! With stacked symbols and juicy fruits, 40 Wild Clover is highly dynamic. To score even bigger wins, get 3 or more Free Games symbols and enter Free Spins feature.',
        features: [
            'Stacked Wilds',
            'Free Spins',
            '40 Lines',
        ],
        links: [
            'asd'
        ],
        imgs: [
            require('../images/games/40-wild-clover/0.jpg'),
            require('../images/games/40-wild-clover/1.jpg'),
            require('../images/games/40-wild-clover/2.jpg'),
            require('../images/games/40-wild-clover/3.jpg'),
            require('../images/games/40-wild-clover/4.jpg'),
        ],
        url: 'https://static.redstone.rs/games/40-wild-clover/'
    },
};


export default dataGames
